import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { ReviewsRoutingModule } from './reviews-routing.module'
import { SharedModule } from '@tv3/shared/shared.module'
import { ReviewsDashboardComponent } from './dashboard/reviews-dashboard.component'
import { ReviewsStatsComponent } from './dashboard/reviews-stats/reviews-stats.component'
import { ReviewsFiltersComponent } from './dashboard/reviews-filters/reviews-filters.component'
import { RecentReviewsComponent } from './dashboard/recent-reviews/recent-reviews.component'
import { ReviewsDistributionComponent } from './dashboard/reviews-distribution/reviews-distribution.component'
import { ReviewsBreakdownComponent } from './dashboard/reviews-breakdown/reviews-breakdown.component'
import { ReviewRepliesBreakdownComponent } from './dashboard/review-replies-breakdown/review-replies-breakdown.component'
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap'
import { TotalReviewsComponent } from './dashboard/total-reviews/total-reviews.component'
import { ReviewRepliesBreakdown2Component } from './dashboard/review-replies-breakdown2/review-replies-breakdown2.component'
import { ReviewsDialogComponent } from './dashboard/reviews-dialog/reviews-dialog.component'
import { ReviewAutomationsModule } from '../automations/review/review-automations.module'
import { ReviewsTableComponent } from './reviews/reviews-table.component'
import { ReviewWidgetComponent } from './review-widget/review-widget.component'
import { RentalAvgRatingComponent } from './dashboard/rental-avg-rating/rental-avg-rating.component'
import { ReviewMontlyAvgRatingComponent } from './dashboard/review-montly-avg-rating/review-montly-avg-rating.component'
import { ReviewMontlyAvgRatingTooltipComponent } from './dashboard/review-montly-avg-rating/tooltip/review-montly-avg-rating-tooltip.component'
import { ReviewsSharedModule } from '@tv3/containers/reviews/reviews-shared.module'
import { ChannelSharedModule } from '@tv3/containers/channels/shared/channel-shared.module'
import { ExportReviewDialogService } from './components/export-dialog/export-reviews-dialog.service'
import { ReviewBookingsTableComponent } from './bookings/review-bookings-table.component'
import { TasksLibModule } from '@tokeet-frontend/tasks'

@NgModule({
  declarations: [
    ReviewsStatsComponent,
    ReviewsFiltersComponent,
    RecentReviewsComponent,
    ReviewsDistributionComponent,
    ReviewsBreakdownComponent,
    TotalReviewsComponent,
    ReviewRepliesBreakdownComponent,
    ReviewRepliesBreakdown2Component,
    ReviewsDashboardComponent,
    ReviewsDialogComponent,
    RentalAvgRatingComponent,
    ReviewMontlyAvgRatingComponent,
    ReviewMontlyAvgRatingTooltipComponent,
    //
    ReviewsTableComponent,

    ReviewWidgetComponent,
    ReviewBookingsTableComponent,
  ],
  imports: [
    //
    CommonModule,
    SharedModule,
    ReviewsRoutingModule,
    NgbProgressbarModule,
    ReviewAutomationsModule,
    ChannelSharedModule,
    ReviewsSharedModule,
    TasksLibModule,
  ],
  providers: [ExportReviewDialogService],
})
export class ReviewsModule {}
